import $ from 'jquery';
import React, { Component } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';



class CompanyData extends Component {

    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;

        var companydata = Comm.CompanyData({ session: sid });
        var companydatabg = Comm.CallServerFunction("invoices/company_data_local", { session: sid });
        console.log("companydatabg", companydatabg);

        this.state = {
            CompanyData: companydata,
            BGCompanyData: companydatabg.data,
            showMissingNameError: false,
            showMissingAddressError: false,
            showMissingLoadingError: false,
            showMissingMolError: false,
            showMissingVatError: false,
            showMissingEoriError: false
        };


        this.SaveCompanyData = this.SaveCompanyData.bind(this);
        this.GetBGData = this.GetBGData.bind(this);
        this.SetBGData = this.SetBGData.bind(this);
    }

    GetBGData(code) {
        return this.state.BGCompanyData.filter(x => x.code === code)[0].data;
    }

    SetBGData(code, value) {
        var cd = this.state.BGCompanyData;
        cd.filter(x => x.code === code)[0].data = value;
        this.setState({ BGCompanyData: cd });
    }


    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }
        if (Context.RenderNotOK(this.props.history))
            return null;

        var self = this;



        return (
            Context.HasRight("rcompanydata") ?
                <div className="panel panel-default">
                    <div className="panel-heading">{Translation.Trans("companydata")}</div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("companyname")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" id="tbName" className="form-control" defaultValue={this.state.CompanyData.name} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingNameError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("address")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" id="tbAddress" className="form-control" defaultValue={this.state.CompanyData.address} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingAddressError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("companyloading")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" id="tbLoading" className="form-control" defaultValue={this.state.CompanyData.loading} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingLoadingError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("mol")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" id="tbMol" className="form-control" defaultValue={this.state.CompanyData.mol} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingMolError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("vat")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" id="tbVat" className="form-control" defaultValue={this.state.CompanyData.vat} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingVatError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("eori")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" id="tbEori" className="form-control" defaultValue={this.state.CompanyData.eori} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingEoriError ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <hr></hr>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("phiscaldevice")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_fiscal_device")} onChange={(e) => self.SetBGData("_fiscal_device", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("phone")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_phone")} onChange={(e) => self.SetBGData("_phone", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("address")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_address")} onChange={(e) => self.SetBGData("_address", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("mol")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_mol")} onChange={(e) => self.SetBGData("_mol", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("city")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_city")} onChange={(e) => self.SetBGData("_city", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("eik")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_eik")} onChange={(e) => self.SetBGData("_eik", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("name")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_name")} onChange={(e) => self.SetBGData("_name", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("eori")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_eori")} onChange={(e) => self.SetBGData("_eori", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("vat")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_vat")} onChange={(e) => self.SetBGData("_vat", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">{Translation.Trans("companyloading")}</label>
                                    </div>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={this.GetBGData("_place_of_loading")} onChange={(e) => self.SetBGData("_place_of_loading", e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {
                                            Context.HasRight("ecompanydata") ?
                                                <div>
                                                    {this.state.showMissingNameError ||
                                                        this.state.showMissingAddressError ||
                                                        this.state.showMissingLoadingError ||
                                                        this.state.showMissingMolError ||
                                                        this.state.showMissingVatError ||
                                                        this.state.showMissingEoriError ? <div className="alert alert-danger">{Translation.Trans("entervalues")}</div> 
                                                        : null}
                                                    <button className="btn btn-primary pull-right" onClick={this.SaveCompanyData}>{Translation.Trans("save")}</button>
                                                </div>
                                                :
                                                null
                                        }

                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>
                :
                <div>{Translation.Trans("noRights")}</div>
        );
    }


    SaveCompanyData() {

        this.setState({
            showMissingNameError: false,
            showMissingAddressError: false,
            showMissingLoadingError: false,
            showMissingMolError: false,
            showMissingVatError: false,
            showMissingEoriError: false

        });
        var canSave = true;
        var name = $("#tbName").val();
        var address = $("#tbAddress").val();
        var loading = $("#tbLoading").val();
        var mol = $("#tbMol").val();
        var vat = $("#tbVat").val();
        var eori = $("#tbEori").val();


        if (name === "") {
            this.setState({ showMissingNameError: true });
            canSave = false;
        }

        if (address === "") {
            this.setState({ showMissingAddressError: true });
            canSave = false;
        }

        if (loading === "") {
            this.setState({ showMissingLoadingError: true });
            canSave = false;
        }

        if (mol === "") {
            this.setState({ showMissingMolError: true });
            canSave = false;
        }

        if (vat === "") {
            this.setState({ showMissingVatError: true });
            canSave = false;
        }

        if (eori === "") {
            this.setState({ showMissingEoriError: true });
            canSave = false;
        }




        if (!canSave)
            return;

        var data = {};
        var sid = Context.GetContext().Sid;
        data.session = sid;

        data.data = JSON.stringify([{ "id": 1, "code": "_name", "data": name },
        { "id": 2, "code": "_address", "data": address },
        { "id": 3, "code": "_place_of_loading", "data": loading },
        { "id": 4, "code": "_mol", "data": mol },
        { "id": 5, "code": "_vat", "data": vat },
        { "id": 6, "code": "_eori", "data": eori }]);

        Comm.SaveCompanyData(data);
        var companydata = Comm.CompanyData({ session: sid });

        data = {
            session: sid,
            data: JSON.stringify(this.state.BGCompanyData)
        };
        Comm.CallServerFunction("invoices/save_company_data_local", data);



        this.setState({
            CompanyData: companydata,
            showMissingNameError: false,
            showMissingAddressError: false,
            showMissingLoadingError: false,
            showMissingMolError: false,
            showMissingVatError: false,
            showMissingEoriError: false
        });




    }



}


export default CompanyData;


// WEBPACK FOOTER //
// ./src/pages/companydata.js